module.exports = __webpack_public_path__ + "static/media/water.4d2c6769.svg";